import { cx, css } from "@emotion/css";
import { themeTokens, letterSpacing, space, text } from "@octopusdeploy/design-system-tokens";
import FrozenDashboardIcon from "~/components/DeploymentFreezes/FrozenDashboardIcon";
import { FrozenResourceType } from "~/components/DeploymentFreezes/FrozenIcon";
// This component is taken from DashboardProjectGroups, duplicated to support the older style of the ProjectDashboard while it's being upgraded
interface ProjectDashboardEnvironmentColumnHeaderProps {
    name: string;
    isFrozen: boolean;
}
export function ProjectDashboardEnvironmentColumnHeader({ name, isFrozen }: ProjectDashboardEnvironmentColumnHeaderProps) {
    return (<div className={styles.cell}>
            <div className={cx(styles.header)} title={name}>
                <div className={cx(styles.name)}>
                    {name}
                    {isFrozen && <FrozenDashboardIcon for={FrozenResourceType.Environment}/>}
                </div>
            </div>
        </div>);
}
const styles = {
    header: css({
        color: themeTokens.color.text.tertiary,
        font: text.body.bold.xSmall,
        letterSpacing: letterSpacing.wider,
        textTransform: "uppercase",
        textAlign: "start",
        paddingTop: space[16],
        paddingLeft: space[8],
        paddingRight: space[8],
        display: "flex",
        justifyContent: "end",
        height: "2.25rem",
        minWidth: "14rem",
    }),
    name: css({
        flex: 1,
        textOverflow: "ellipsis",
        overflow: "hidden",
    }),
    cell: css({
        padding: 0,
    }),
};
